// @ts-nocheck
import React, { useState, useEffect, useContext, useRef } from 'react';
import Button from '@/components/button';
import NoSSR from '@/utils/no-ssr'
import Breadcrumbs from '@/components/breadcrumbs';
import Search from '@/components/search';
import CellStatus from '@/components/cells/status-old';
import CellDate from '@/components/cells/date';
import CellBold from '@/components/cells/bold';
import CellTech from '@/components/cells/tech';
import CellWide from '@/components/cells/wide';
import CellCheckbox from '@/components/cells/checkbox';
import CellCurrency from '@/components/cells/currency';
import CellNumber from '@/components/cells/number';
import CellBool from '@/components/cells/bool';
import ColumnSelect from '@/components/column-select';
import KendoPager from '@/components/kendo/kendo-pager';
import Router from 'next/router';
import Fetch from '@/utils/Fetch';
import * as Enums from '@/utils/enums';
import ToastContext from '@/utils/toast-context';
import CreateImport from '@/components/modals/import/create';
import Storage from '@/utils/storage';
import Helper from '@/utils/helper';
import WarrantyIndicator from '@/components/product/warranty-indicator';
import UCS from '@/services/option/user-config-service';
import PS from '@/services/permission/permission-service';
import KendoCellWarrantyIndicator from '@/components/kendo/cells/kendo-cell-warranty-indicator';
import KendoTable from '@/components/kendo/kendo-table';
import KendoCellEmployee from '@/components/kendo/cells/kendo-cell-employee';
import KendoCellDate from '@/components/kendo/cells/kendo-cell-date';
import KendoCellCurrency from '@/components/kendo/cells/kendo-cell-currency';
import KendoCellNumber from '@/components/kendo/cells/kendo-cell-number';
import KendoCellStatus from '@/components/kendo/cells/kendo-cell-status';
import KendoCellBool from '@/components/kendo/cells/kendo-cell-bool';
import DownloadDropdown from '@/components/download-dropdown';
import { createFileRoute } from '@tanstack/react-router'



function ProductList() {

  const toast = useContext(ToastContext);

  const [columnState, setColumnState] = useState<any[]>([]);
  const [availableColumns, setAvailableColumns] = useState<any[]>([]);
  const [requiredColumns, setRequiredColumns] = useState<any[]>([]);
  const [selectedColumns, setSelectedColumns] = useState<any[]>([]);

  const [filtersConfig, setFiltersConfig] = useState<any>(null);

  const [filters, setFilters] = useState<any>(null);

  const ancillaryFiltersDef = {
    IncludeScrapped: [{
      type: Enums.ControlType.Switch,
      label: 'Include scrapped assets',
    }],
  };

  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);

  const [isMasterOfficeAdmin] = useState(PS.hasPermission(Enums.PermissionName.MasterOfficeAdmin));

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  const checkboxColumnHeader = 'Number';
  const checkboxColumn = 'ProductNumber';

  const columns = React.useMemo(
    () => columnState.filter((column: any) => column.Show == true).map(function (column: any) {
      let columnObject = {
        Header: column.Label,
        accessor: column.ColumnName,
        // for table resize columns
        ColumnName: column.ColumnName,
        UserWidth: column.UserWidth
        // for table resize columns
      }

      if (column.CellType != "none") {
        switch (column.CellType) {
          case 'select':
          case 'check':
            columnObject['accessor'] = (row: any) => { return { ProductNumber: row.ProductNumber, ID: row.ID } };
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellCheckbox value={value.ProductNumber} itemId={value.ID} key={value}
              selectedItems={selectedProducts} setSelectedItems={setSelectedProducts} />;
            break;
          case 'employee':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellTech value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellEmployee {...props} employeesField="Employees" />;
            break;
          case 'date':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellDate value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellDate {...props} />;
            break;
          case 'currency':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellCurrency value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellCurrency {...props} />;
            break;
          case 'int':
          case 'int?':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellNumber value={value} isDecimal={false} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellNumber {...props} isDecimal={false} />;
            break;
          case 'decimal':
          case 'decimal?':
            columnObject['extraClasses'] = 'header-right-align';
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellNumber value={value} isDecimal={true} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellNumber {...props} isDecimal={true} />;
            break;
          case 'status':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellStatus value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellStatus {...props} />
            break;
          case 'icon':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBool value={value} />;
            columnObject['KendoCell'] = (props: any) => <KendoCellBool {...props} />;
            break;
          default:
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBold value={value} />;
        }
      }

      if (column.ColumnName == 'LocationDisplay') {
        columnObject['accessor'] = (row: any) => {
          if (row.Location) {
            return row.Location.LocationDisplay;
          } else {
            return row.LocationDescription;
          }
        }
        columnObject['Cell'] = ({ cell: { value } }: any) => <CellWide value={value} />;
      }

      if (column.ColumnName === "WarrantyPeriod") {
        columnObject['accessor'] = (row: any) => {
          return row;
        }
        columnObject['Cell'] = ({ cell: { value } }: any) => <WarrantyIndicator purchaseDate={value.PurchaseDate} warrantyPeriod={value.WarrantyPeriod} />;
        columnObject['KendoCell'] = (props: any) => <KendoCellWarrantyIndicator {...props} />
      }

      return columnObject;
    }),
    [columnState, selectedProducts]
  );

  function setColumn(selected: any) {
    let newColumns = [...selectedColumns];
    if (newColumns.includes(selected)) {
      newColumns = newColumns.filter((value: any) => { return value !== selected })
    } else {
      newColumns.push(selected);
    }
    setSelectedColumns(newColumns);

    const newState = columnState.map(function (column: any) {
      if (column.Label == selected) {
        column.Show = !column.Show;
      }
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }

  async function setReorder(updatedOptions: any) {

    const newState = updatedOptions.map((item: any, index: any) => {
      let column = columnState.find((x: any) => x.Label == item);
      column.Order = index;
      return column;
    });

    setAvailableColumns(updatedOptions);
    setColumnState(newState);

    columnMappingPut(newState);
  }

  async function columnMappingPut(newState: any) {
    await Fetch.put({
      url: '/Employee/ColumnMapping',
      params: {
        ColumnMappings: newState,
        model: 'ProductList',
      },
      toastCtx: toast
    });
  }

  // for table resize columns
  async function resetColumnWidths() {
    const newState = columnState.map(function (column: any) {
      column.UserWidth = null;
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }

  async function onColumnResize(columnName: any, width: any, columnNamesAndWidths: any) {
    const newState = columnState.map(function (column: any) {
      if (column.ColumnName === columnName) {
        column.UserWidth = width;
      } else if (columnNamesAndWidths) {
        let match = columnNamesAndWidths.find((x: any) => x.columnName === column.ColumnName);
        if (match) {
          column.UserWidth = match.width;
        }
      }
      return column;
    });
    setColumnState(newState);
    columnMappingPut(newState);
  }
  // for table resize columns

  const [productResults, setProductResults] = useState([{}]);
  const [searching, setSearching] = useState(false);
  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [searchVal, setSearchVal] = useState('');
  const [activeFilterIds, setActiveFilterIds] = useState<any>({});
  const [ancillaryFilters, setAncillaryFilters] = useState<any>({});
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const handleAncillaryFilterChange = (result: any) => {
    if (result.reset) {
      setAncillaryFilters({ IncludeScrapped: false });
    } else {
      if (result.key == 'IncludeScrapped') {
        setAncillaryFilters({ IncludeScrapped: result.checked });
      }
    }
  };

  const [pageSize, setPageSize] = useState(Storage.getCookie(Enums.Cookie.pageSize) ? parseInt(Storage.getCookie(Enums.Cookie.pageSize)) : 10);

  const pageSizeChanged = (size: any) => {
    if (size != pageSize) {
      setPageSize(size);
    }
  };

  const pageChanged = (page: any) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const init = async () => {
      const [filtersConfigResult, categoriesResult, subCategoriesResult, storesResult, columnsResult] = await Promise.all([
        UCS.getPageFilters(Enums.ConfigurationSection.Product),
        Fetch.get({ url: '/InventoryCategory/false' }),
        Fetch.get({ url: '/InventorySubcategory/GetOnlyActive?onlyActive=false' }),
        Fetch.post({ url: '/Store/GetStores' }),
        Fetch.get({ url: '/Employee/ColumnMapping?model=ProductList' }),
      ]);

      const [activeFilterIdsDefault, ancillaryFiltersDefault, sortExpressionDefault, sortDirectionDefault] = UCS.getFilterValues(
        filtersConfigResult, ["Categories", "Subcategories", "CustomerGroups", "Stores"], [],
        ["IncludeScrapped"], false);

      const isMultiStore = storesResult.TotalResults > 1;

      let filtersObj = {
        Categories: categoriesResult.Results,
        Subcategories: subCategoriesResult.Results,
      };
      if (isMultiStore) {
        filtersObj = { ...filtersObj, Stores: storesResult.Results };
      }

      let columnResults = columnsResult.Results;
      if (!isMultiStore) {
        columnResults = columnResults.filter((x: any) => x.ColumnName !== 'StoreName');
      }

      setFiltersConfig(filtersConfigResult);
      setFilters(filtersObj);
      setColumnState(columnResults);
      setAvailableColumns(columnResults.map((c: any) => c.Label));
      setRequiredColumns(columnResults.filter((c: any) => c.IsRequired).map((c: any) => c.Label));
      setSelectedColumns(columnResults.filter((c: any) => c.Show).map((c: any) => c.Label));
      setSortField(sortExpressionDefault);
      setSortDirection(sortDirectionDefault);
      setActiveFilterIds(activeFilterIdsDefault);
      setAncillaryFilters(ancillaryFiltersDefault);
      getAccessStatus();
      setExportOptionsList();
    };
    init();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  const oldcurrentPage = useRef(currentPage);
  useEffect(() => {
    let changed = oldcurrentPage.current !== currentPage;
    oldcurrentPage.current = currentPage;

    if (changed) {
      searchProducts();
    }
  }, [currentPage]);

  const oldsearchVal = useRef(searchVal);
  const oldsortField = useRef(sortField);
  const oldsortDirection = useRef(sortDirection);
  const oldpageSize = useRef(pageSize);
  const oldancillaryFilters = useRef(ancillaryFilters);
  const oldactiveFilterIds = useRef(activeFilterIds);

  useEffect(() => {

    let changed = oldsearchVal.current !== searchVal
      || oldsortDirection.current !== sortDirection
      || oldsortField.current !== sortField
      || oldpageSize.current !== pageSize
      || Helper.jsonCompare(oldancillaryFilters.current, ancillaryFilters)
      || Helper.jsonCompare(oldactiveFilterIds.current, activeFilterIds);

    oldsearchVal.current = searchVal;
    oldsortField.current = sortField;
    oldsortDirection.current = sortDirection;
    oldpageSize.current = pageSize;
    oldancillaryFilters.current = ancillaryFilters;
    oldactiveFilterIds.current = activeFilterIds;

    if (!changed) return;

    if (currentPage == 1) {
      searchProducts();
    } else {
      setCurrentPage(1);
    }
  }, [sortField, sortDirection, activeFilterIds, ancillaryFilters, pageSize]);

  function setSort(field: any) {
    setSortDirection(Helper.getSortDirection(field, sortField, sortDirection));
    setSortField(field);
  }

  async function searchProducts() {

    setSearching(true);

    let params = {
      pageSize: pageSize,
      pageIndex: (currentPage - 1),
      searchPhrase: searchVal,
      CategoryIDList: activeFilterIds["Categories"],
      SubcategoryIDList: activeFilterIds["Subcategories"],
      //EmployeeIDList: activeFilterIds["Employees"],
      CustomerGroupIDList: activeFilterIds["CustomerGroups"],
      IncludeScrapped: ancillaryFilters["IncludeScrapped"],
      StoreIDList: activeFilterIds["Stores"],
      SortExpression: sortField === checkboxColumnHeader ? checkboxColumn : sortField,
      SortDirection: sortDirection,
    };

    const products = await Fetch.post({
      url: `/Product/GetProducts`,
      params: params
    });

    // filtersConfig code
    let filtersConfigTemp = { ...filtersConfig };
    UCS.updateFilters(filtersConfigTemp, activeFilterIds, ancillaryFilters, sortField, sortDirection);
    UCS.saveConfigDebounced(filtersConfigTemp);
    setFiltersConfig(filtersConfigTemp);
    // filtersConfig code

    setProductResults(products.Results);
    setTotalResults(products.TotalResults);
    setSearching(false);
  }

  function rowClick(row: any) {
    Helper.nextRouter(Router.push, '/asset/[id]', `/asset/${row.original.ID}`);
  }

  function selectAll() {
    if (productResults.length == selectedProducts.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(productResults.map((result: any) => result.ID));
    }
  }

  const [scrapping, setScrapping] = useState(false);
  async function scrapProduct(product: any) {
    setScrapping(true);

    const scrap = await Fetch.get({
      url: `/Product/ProductScrapToggle?id=${product.ID}&isScrapped=${true}`,
      toastCtx: toast
    });

    if (scrap.ID) {
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          await Fetch.get({
            url: `/Product/ProductScrapToggle?id=${product.ID}&isScrapped=${false}`,
          });
          searchProducts();
        },
        message: 'Asset scrapped successfully',
        show: true,
        type: 'success'
      });
      searchProducts();
    }
    setScrapping(false);
  }

  const [scrappingSelected, setScrappingSelected] = useState(false);
  const scrapSelected = async () => {
    setScrappingSelected(true);

    const productsScrapped = await Fetch.post({
      url: '/Product/ProductListScrapToggle',
      params: selectedProducts,
      toastCtx: toast
    });

    if (productsScrapped) {
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          await Fetch.post({
            url: '/Product/ProductListScrapToggle',
            params: selectedProducts
          });
          searchProducts();
        },
        message: 'Asset scrapped successfully',
        show: true,
        type: 'success'
      });
      searchProducts();
    }

    setSelectedProducts([]);
    setScrappingSelected(false);
  }  

  const [showImportModal, setShowImportModal] = useState(false);

  const [exportOptions, setExportOptions] = useState<any[]>([]);
  const [exportPermission] = useState(PS.hasPermission(Enums.PermissionName.Exports));

  const setExportOptionsList = () => {
    let exportOpts = [];
    exportOpts.push({ url: '/Product/GetExportedProducts', method: 'POST', params: { ...params, ExportAll: false }, label: 'Filtered export' });    
    exportOpts.push({ url: '/Product/GetExportedProducts', method: 'POST', params: { ...params, ExportAll: true }, label: 'Full export' });
    
    setExportOptions(exportOpts);
  };

  const [params, setParams] = useState<any>({});

  useEffect(() => {
    setParams({
      searchPhrase: searchVal,
      CategoryIDList: activeFilterIds["Categories"],
      SubcategoryIDList: activeFilterIds["Subcategories"],
      CustomerGroupIDList: activeFilterIds["CustomerGroups"],
      IncludeScrapped: ancillaryFilters["IncludeScrapped"],
      StoreIDList: activeFilterIds["Stores"],
    });
  }, [searchVal, activeFilterIds, ancillaryFilters]);

  useEffect(() => {
    setExportOptionsList();
  }, [params]);

  const createProduct = () => {
    Helper.nextRouter(Router.push, "/asset/create");
  };

  const getTableActions = () => {
    let acts = [
      { text: "Edit", icon: "edit", function: (row: any) => Helper.nextRouter(Router.push, '/asset/[id]', `/asset/${row.ID}`) }
    ];

    if (accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess) {
      acts.push({ text: (scrapping ? "Scrapping" : "Scrap Asset"), icon: "check-square-blue", function: scrapProduct });
    }

    return acts;
  };

  return (
    <div className="list-container">
      <div className="row">
        <div className="title">
          <Breadcrumbs currPage={{ text: 'Asset List', link: '/customer/list?tab=assets', type: 'list' }} />
        </div>
        <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
          text="Create" icon="plus-circle" extraClasses="fit-content no-margin" onClick={createProduct} />
      </div>
      <div className="row end padded">
        <NoSSR>
          <div className="search-container">
            <Search
              filters={filters}
              placeholder="Search asset code or description"
              resultsNum={productResults.length}
              searchVal={searchVal}
              setActiveFilterIds={setActiveFilterIds}
              ancillaryFilters={ancillaryFiltersDef}
              setAncillaryFilters={handleAncillaryFilterChange}
              setSearchVal={setSearchVal}
              filtersConfig={filtersConfig}
            />
          </div>
          <div className="row end">
            {selectedProducts.length > 0
              ? <div className="select-actions">
                <Button text={scrapping ? "Scrapping" : "Scrap Selected"} icon="check-square-blue" extraClasses="white-action"
                  onClick={scrapping ? null : scrapSelected} />
              </div>
              : ''
            }
            {accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess && isMasterOfficeAdmin ? <>
              <div title="Import" className="import-container" onClick={() => setShowImportModal(true)}>
                <img src={Enums.Icon.Upload} alt="icon" className="import-icon" />
                {showImportModal ?
                  <CreateImport setShowModal={setShowImportModal} importType={Enums.ImportType.Asset} /> : ''
                }
              </div>
            </> : ""}

            {accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess && exportPermission ? <>
                <div className="download">
                  <DownloadDropdown title={'Export'} options={exportOptions} />
                </div>
              </> : ''}

            <ColumnSelect options={availableColumns} selected={selectedColumns} requiredColumns={requiredColumns} setColumn={setColumn} setReorder={setReorder}
              resetColumnWidths={resetColumnWidths} />
          </div>
        </NoSSR>
        
      </div>

      <div className={"no-items" + (productResults.length == 0 ? " no-items-visible" : "")}>
        <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
          <div className="loader"></div>
        </div>
        <img src="/job-folder.svg" alt="Asset Folder" />
        <h3>No assets found</h3>
        <p>If you can't find a asset, try another search or create a new one.</p>
        <a href="/asset/create"><img src="/icons/plus-circle-blue.svg" alt="plus" /> Add new asset</a>
        <img className="wave" src="/wave.svg" alt="wave" />
      </div>

      {productResults.length != 0 ? <KendoTable
        searching={searching}
        actions={getTableActions()}
        columns={columns}
        data={productResults}
        rowClick={rowClick}
        setSort={setSort}
        sortField={sortField}
        sortDirection={sortDirection}
        type="Asset"
        // for table resize columns
        onColumnResize={onColumnResize}
        // for table resize columns
        canSelectItems={true}
        selectedItems={selectedProducts}
        setSelectedItems={setSelectedProducts}
        heightOffset={300}
        highlightColumnName="ProductNumber"
      /> : ""}

      <KendoPager pageSizeChanged={pageSizeChanged} pageChanged={pageChanged} totalResults={totalResults} searchValue={searchVal} parentPageNumber={currentPage} />

      <style jsx>{`
        .column {
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .padded {
          padding-bottom: 1rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        a {
          text-decoration: none;
        }
        .select-actions {
          display: flex;
          margin-right: 0.5rem;
        }
        .select-actions :global(.white-action) {
          font-size: 0.875rem;
          margin: 0 0 0 1rem; 
          width: auto;
        }
        .select-actions :global(.icon) {
          left: 1rem !important;
        }
        .download {
          margin-right: 0.5rem;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}

export default ProductList;

export const Route = createFileRoute('/_authenticated/asset/list')({ component: ProductList })
